import { render } from "./RegistrationPersonalInfo.vue?vue&type=template&id=4261abf2&scoped=true&lang=pug"
import script from "./RegistrationPersonalInfo.vue?vue&type=script&lang=js"
export * from "./RegistrationPersonalInfo.vue?vue&type=script&lang=js"

import "./RegistrationPersonalInfo.vue?vue&type=style&index=0&id=4261abf2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4261abf2"]])

export default __exports__